import { JSX } from 'react';
import { C41TableProps } from './C41Table.types';
import { TableContainer } from '@ahc-digital/component-library';
import { GetTableModel } from './C41Table.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C41TableProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <TableContainer
      {...GetTableModel(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C41TableProps>(Default);
